import { LegalClientBodyType } from 'api/types/entity';
import {
  TypedForm,
  FormErrors as FormErrorsBase,
  ObjectSchema,
  string,
  object,
  selectSchema,
} from 'libs/form';
import { SelectType } from 'types/selectType';

export interface CompanyStructureFormType {
  id?: string;
  type: SelectType<LegalClientBodyType>;
  name: string;
  otherType?: string;
}

export const MAX_AUTHORITIES = 10;

export const getSchema = (): ObjectSchema<CompanyStructureFormType> =>
  object({
    id: string(),
    type: selectSchema(Object.values(LegalClientBodyType)).required(),
    name: string().max(200).required(),
    otherType: string().when('type', {
      is: (value?: SelectType<LegalClientBodyType>) =>
        value?.value === LegalClientBodyType.Other,
      then: (schema) => schema.required().max(200),
    }),
  });

export const emptySchema = object({});

export const { Field, Form, useFormContext, Submit } =
  TypedForm<CompanyStructureFormType>();

export type FormErrors = FormErrorsBase<CompanyStructureFormType>;
